import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { isMobile } from 'react-device-detect';
import BG from '../assets/sp-bg-2.jpg';
import GCFlag from '../assets/sig-blk-en.svg';
import WMMS from '../assets/wmms-blk.svg';
import '../assets/gcweb-theme.css';
import '../assets/gcweb-splash.css';

const LanguageSelectPage: React.FC = () => {
  const navigate = useNavigate();
  const { setLanguage } = useLanguage();
  const handleSelect = (lang: 'en' | 'fr') => {
    setLanguage(lang);
    navigate('/apply/form', { state: { language: lang } });
  };

  if (!isMobile) {
    return (
      <div className="splash">
        <div id="bg">
          <img src={BG} alt="" />
        </div>
        <main>
          <div className="sp-hb">
            <div className="sp-bx col-xs-12">
              <h1 className="wb-inv">Canada.ca</h1>
              <div className="row">
                <div className="col-xs-11 col-md-8">
                  <img src={GCFlag} width="283" alt="Government of Canada" />
                  <span className="wb-inv"> / <span lang="fr">Gouvernement du Canada</span></span>
                </div>
              </div>
              <div className="row">
                <section className="col-xs-6 text-right">
                  <h2 className="wb-inv">Government of Canada</h2>
                  <p>
                    <a 
                      href="/apply/form" 
                      className="btn btn-primary" 
                      onClick={(e) => { e.preventDefault(); handleSelect('en'); }}
                      translate="no"
                    >
                      English
                    </a>
                  </p>
                </section>
                <section className="col-xs-6" lang="fr">
                  <h2 className="wb-inv">Gouvernement du Canada</h2>
                  <p>
                    <a 
                      href="/apply/form" 
                      className="btn btn-primary" 
                      onClick={(e) => { e.preventDefault(); handleSelect('fr'); }}
                      translate="no"
                    >
                      Français
                    </a>
                  </p>
                </section>
              </div>
            </div>
            <div className="sp-bx-bt col-xs-12">
              <div className="row">
                <div className="col-xs-7 col-md-8">
                  <a href="https://www.canada.ca/en/transparency/terms.html" className="sp-lk">Terms and conditions</a>
                  {' '}<span className="glyphicon glyphicon-asterisk"></span>{' '}
                  <a href="https://www.canada.ca/fr/transparence/avis.html" className="sp-lk" lang="fr">Avis</a>
                </div>
                <div className="col-xs-5 col-md-4 text-right mrgn-bttm-md">
                  <img src={WMMS} width="127" alt="Symbol of the Government of Canada" />
                  <span className="wb-inv"> / <span lang="fr">Symbole du gouvernement du Canada</span></span>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  } else {
    return (
      <div className="splash min-h-screen">
        <div id="bg" className="fixed inset-0 -z-10">
          <img src={BG} alt="" className="w-full h-full object-cover" />
        </div>
        <main className="min-h-screen px-3 pt-[0px]">
          <div className="mx-auto flex w-full justify-center">
            <div className="sp-hb flex w-full max-w-[300px] flex-col md:max-w-[403px]">
              <div className="sp-bx w-full rounded-none px-4 py-4 shadow-none md:px-5 md:py-5">
                <h1 className="wb-inv">Canada.ca</h1>
                <div className="mb-2 flex justify-center">
                  <div className="text-center">
                    <img src={GCFlag} width="220" alt="Government of Canada" className="mx-auto max-w-full md:w-[240px]" />
                    <span className="wb-inv">
                      {' '}/ <span lang="fr">Gouvernement du Canada</span>
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-10 md:gap-4">
                  <section className="text-center">
                    <h2 className="wb-inv">Government of Canada</h2>
                    <p>
                      <a
                        href="/apply/form"
                        className="btn btn-primary block w-full py-2 text-base md:py-3 md:text-lg"
                        onClick={(e) => {
                          e.preventDefault();
                          handleSelect('en');
                        }}
                        translate="no"
                      >
                        English
                      </a>
                    </p>
                  </section>
                  <section className="text-center" lang="fr">
                    <h2 className="wb-inv">Gouvernement du Canada</h2>
                    <p>
                      <a
                        href="/apply/form"
                        className="btn btn-primary block w-full py-2 text-base md:py-3 md:text-lg"
                        onClick={(e) => {
                          e.preventDefault();
                          handleSelect('fr');
                        }}
                        translate="no"
                      >
                        Français
                      </a>
                    </p>
                  </section>
                </div>
              </div>

              <div className="sp-bx-bt mt-auto w-full px-4 py-3 md:px-5 md:py-4">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex flex-col gap-1 text-md leading-normal">
                    <div className="flex items-center gap-1">
                      <a href="https://www.canada.ca/en/transparency/terms.html" className="sp-lk">
                        Terms and conditions <span className="mx-1">•</span>
                      </a>
                    </div>
                    <a href="https://www.canada.ca/fr/transparence/avis.html" className="sp-lk" lang="fr">
                      Avis
                    </a>
                  </div>
                  <div className="flex flex-col items-end">
                    <img src={WMMS} width="127" alt="Symbol of the Government of Canada" className="w-[105px] md:w-[127px]" />
                    <span className="wb-inv">
                      {' '}/ <span lang="fr">Symbole du gouvernement du Canada</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
};

export default LanguageSelectPage;